import LoginApi from '@api/LoginApi'

export default {
  methods: {
    logout () {
      new LoginApi()
        .logout()
        .then(response => {
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          // we use this instead of $router.push so it will also purge all
          // no persisted state. Persisted state is cleared through the
          // cacheBuster.NUKE_STATE action on Login.vue
          window.location.href = '/'
        })
    },
    logoutWithSso () {
      new LoginApi()
        .logout()
        .then(response => {
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          // for sso, cacheBuster.NUKE_STATE on AuthSsoLogout.vue
          this.$router.push({ name: 'sso-logout' })
        })
    }
  }
}
